import React from "react";
import Modal from "@/components/common/Modal";
import "./index.css";
import type { TravelDetailsProps } from "../../components/sections/steps/SummaryStep";

interface PaymentTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: "pending" | "overlap";
  travelDetails: TravelDetailsProps | null;
}

const TITLES = {
  pending: "Finish your current payment first",
  overlap: "Ooops!",
};

const PaymentTransactionModal: React.FC<PaymentTransactionModalProps> = ({
  isOpen,
  onClose,
  type,
  travelDetails,
}) => {
  const handleContinue = () => {
    if (travelDetails?.payment_link) window.open(travelDetails.payment_link, "_self");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      showCloseButton={false}
      size="large"
      className="payment-transaction-modal"
    >
      <div className="content-wrapper">
        <div className="modal-header">
          <div className="modal-title-section">
            <h2 className="modal-title">{TITLES[type]}</h2>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>

        {type === "overlap" && (
          <>
            <p className="my-5 pt-2">
              It seems like you just bought Travel Insurance that already covers some of these dates.
              {(travelDetails?.coverage_start || travelDetails?.coverage_end) && (
                <span> [{travelDetails.coverage_start} and {travelDetails.coverage_end} of existing policy].</span>
              )}
            </p>
            <p className="mb-4">
              Please double check your coverage period, as you cannot purchase insurance with
              overlapping dates. For more info and assistance, please e-mail{" "}
              <a href="mailto:travelonline@pacificcross.com.ph" className="overlap-email-link">
                travelonline@pacificcross.com.ph
              </a>
            </p>
          </>
        )}

        {type === "pending" && (
          <>
            <p className="my-5 pt-2">You already have a pending payment for this plan.</p>
            <p className="font-bold mb-1">Travel details:</p>
            <ul className="mb-3 pl-4 list-disc space-y-0.5">
              <li>Dates:[{travelDetails?.coverage_start} - {travelDetails?.coverage_end}]</li>
              <li>Itinerary: [{travelDetails?.itinerary}]</li>
            </ul>
            <p className="my-4">To avoid duplicate charges, please continue your existing payment.</p>
            <p className="mb-4">This payment link will expire in 10 minutes.</p>
          </>
        )}

        <div className="flex justify-end">
          <button
            type="button"
            className="btn-pay flex items-center justify-center"
            onClick={type === "overlap" ? onClose : handleContinue}
          >
            {type === "overlap" ? "Okay" : "Continue Payment"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentTransactionModal;
